module.exports = __webpack_public_path__ + "static/media/gameplay1.42255301.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/gameplay1.png
// module id = 185
// module chunks = 0